/**
 * Admin-PINs pro Raid-ID (Klartext, nur lokal).
 *
 * Hinweis: `http://localhost:…` und `http://127.0.0.1:…` sind unterschiedliche Origins – jeweils eigenes localStorage.
 */
const STORAGE_KEY = "dune-raid-admin-pins";

function readStore(): Record<string, string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as Record<string, string>;
    }
    return {};
  } catch {
    return {};
  }
}

function writeStore(map: Record<string, string>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    console.error("[pinStore] localStorage setItem fehlgeschlagen", e);
  }
}

export function getPinForRaid(raidId: number): string | undefined {
  const v = readStore()[String(raidId)];
  return v && v.length > 0 ? v : undefined;
}

export function storePinForRaid(raidId: number, pin: string) {
  if (!pin) return;
  const m = readStore();
  m[String(raidId)] = pin;
  writeStore(m);
}
